import { render } from "./what-strategic-connection.vue?vue&type=template&id=7f0f5503&lang=pug"
import script from "./what-strategic-connection.vue?vue&type=script&lang=js"
export * from "./what-strategic-connection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__